import { AdLogo } from 'core/adLogo/AdLogo';
import { LineMessageFormData } from 'core/advertiser/LineBeacon';
import { TenMaxBeaconMessageFormData } from 'core/advertiser/TenmaxBeacon';
import { Creative, CreativeType } from 'core/creative/Creative';
import { LimitationData } from 'core/limitation/Limitation';
import { ElementType } from 'react';

export type CreativeFormBasicData = {
  creativeId?: number;
  tenmaxCategory: string;
  enableNativeBanner?: boolean;
  nativeBanner?: { [key: string]: any };
  creativeType: CreativeType;
  name?: string;
  landingPageUrl?: string;
  bannerUrl?: string;
  advertiserId?: number;
  typeProperties?: any;
  medias?: any;
  enableStartTime?: string;
  enableEndTime?: string;
  adLogo?: AdLogo;
  lineMessage?: LineMessageFormData[];
  tenMaxBeaconMessage?: TenMaxBeaconMessageFormData;
};

export type CreativeFormData = {
  basic: CreativeFormBasicData;
  limitations?: any;
};

export interface FormContentModel {
  readonly needBannerUrl: boolean;
  readonly defaultAdLogo?: AdLogo;
  /**
   * 素材的「開始／結束時間」要不要整個藏起來。
   *
   * 由內容 model 回答是因為這件事取決於銷售渠道，而渠道 id 只有內容 model 拿得到；
   * 基本資料表單本身沒有渠道概念，讓它去查會多牽一條依賴。
   */
  readonly hideCreativeEnableTime: boolean;
  init: () => Promise<void>;
  isAdLogoSupported: (creative: CreativeFormBasicData) => boolean;
  getFormContent: () => any;
  getInitTypeProperties: () => any;
  getInitLimitations: () => {
    include: any[];
    exclude: any[];
    nonPreferred: any[];
    other: any[];
    preferred: any[];
  };
  getFormModelData: (creative: Creative) => CreativeFormData;
  setLimitationHook(
    addLimitation: (
      operate: string,
      limitationType: string,
      label: string,
      value: string
    ) => void
  ): void;
}

export abstract class AbstractFormContentModel implements FormContentModel {
  public needBannerUrl = true;

  get hideCreativeEnableTime(): boolean {
    return false;
  }

  abstract getFormContent(): ElementType;
  abstract getInitTypeProperties(): { [key: string]: any } | undefined;
  abstract getFormModelData(creative: Creative): CreativeFormData;
  abstract setLimitationHook(
    addLimitation: (
      operate: string,
      limitationType: string,
      label: string,
      value: string
    ) => void
  ): void;

  async init() {
    /* no-op */
  }

  public get defaultAdLogo(): AdLogo | undefined {
    return undefined;
  }

  isAdLogoSupported(_1): boolean {
    return !!this.defaultAdLogo;
  }

  getInitLimitations(): LimitationData {
    return {
      include: [],
      exclude: [],
      nonPreferred: [],
      other: [],
      preferred: []
    };
  }
}
